import { error } from 'services/graphql/fragments/Fragments';
import { gql } from 'urql';

const CurrentIncentives = gql`
  query CurrentIncentives($input: CurrentIncentivesInput!) {
    currentIncentives(input: $input) {
      __typename
      ... on CurrentIncentivesSuccess {
        incentives {
          id
          incentiveType
          name
          programContent
          programContentSchemaVersion
          status
          windowStart
          windowEnd
          termsAndConditionsVersion
          termsAndConditionsUrl
        }
      }
      ... on CurrentIncentivesError {
        ...error
      }
    }
  }
  ${error}
`;

export default CurrentIncentives;
